import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { DELETE_GSC_LISTING_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const useDeleteListing = ({ onSuccess, onError }: Input) => {
  const deleteListing = async (uuid: string) => {
    await axiosClient.delete(DELETE_GSC_LISTING_URL(uuid));
  };

  return useCustomMutation(deleteListing, {
    onSuccess,
    onError,
  });
};
